<template>

<div class="form inner">

    <div class="form-text">{{ item.text }}</div>

	<p class="form-message is-success" v-if="is.success">Thank you, your submission has been received.</p>
	<p class="form-message is-error" v-if="is.errored">Sorry, there was an error. Please try again.</p>

    <div class="form-inputs">

        <app-backend-icon icon="loading" v-if="is.loading" class="form-inputs-loading" />
        
        <template v-if="!is.success">

            <template v-for="input in inputs">

                <com-textbox :input="input" v-model="model[input.id]" v-if="input.type === $constants.inputType.textbox" :key="input.id" />
                <com-textarea :input="input" v-model="model[input.id]" v-if="input.type === $constants.inputType.textarea" :key="input.id" />
                <com-select :input="input" v-model="model[input.id]" v-if="input.type === $constants.inputType.select" :key="input.id" />
                <com-checkbox :input="input" v-model="model[input.id]" v-if="input.type === $constants.inputType.checkbox" :key="input.id" />

            </template>

        </template>

    </div>

    <div class="form-button" :class="{'is-disabled': is.submitting || $v.$invalid}" v-on:click="onSubmitClick" v-if="!is.success">
		<template v-if="!is.submitting">{{ item.button }}</template>
		<i class="fa fa-spinner fa-spin" v-if="is.submitting"></i>
	</div>

</div>

</template>

<script>

import comTextbox from './form/Textbox'
import comTextarea from './form/Textarea'
import comSelect from './form/Select'
import comCheckbox from './form/Checkbox'

import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import Vue from 'vue'

export default {

	mixins: [validationMixin],

    props: ['item'],

    components: {
        'com-textbox': comTextbox,
        'com-textarea': comTextarea,
        'com-select': comSelect,
        'com-checkbox': comCheckbox
    },

    data: function() {
    
        return {
            is: {
                loading: true,
                submitting: false,
                success: false,
                errored: false
            },
            inputs: [],
            model: {}
        }

    },

	watch: {

		model: {

			handler: function(e) {

                console.log(e)
				this.$v.$touch()

			},

			deep: true

		} 

	},

    validations: function() {

        var validation = {
            model: {}
        }

        this.$_.each(this.inputs, function(input) {

            validation.model[input.id] = { required }

        })

        return validation

    },

    created: function() {
    
        this.load()
    
    },

    methods: {

        onSubmitClick: function() {

			if (this.is.submitting || this.$v.$invalid) return false

			this.is.submitting = true
			this.is.errored = false

			this.$api.post('../frontend/form', {
                form: this.item.form,
                model: this.model
            }).then(function() {

				this.is.submitting = false
				this.is.success = true

			}.bind(this), function() {

				this.is.submitting = false
				this.is.errored = true

			}.bind(this))

        },
    
        load: function() {
        
            this.$api.get('../frontend/form', {
                form: this.item.form
            }).then(function(response) {
            
                this.$vueset(this, 'inputs', response.inputs)

                this.$_.each(this.inputs, function(input) {

                    Vue.set(this.model, input.id, null)

                }.bind(this))

                this.is.loading = false

            }.bind(this))
        
        }
    
    }

}

</script>

<style scoped>

.form {
    max-width: 640px;
    padding: 0px 0px;
    margin: 0px auto;
    margin-top: -20px;
}

.is-tablet .form {
    padding: 0px 0px;
}

.is-mobile .form {
    padding: 0px 10px;
}

.form-text {
    color: #45464B;
    font-size: 16px;
    line-height: 28px;
    font-weight: 500;
    font-family: "Montserrat", sans-serif;
    text-align: center;
    margin-bottom: 20px;
}

.is-tablet .form-text {
    font-size: 14px;
    line-height: 24px;
}

.is-mobile .form-text {
    font-size: 13px;
    line-height: 24px;
}

.form-inputs {
    padding: 0px 0px 40px 0px;
    min-height: 64px;
}

.is-mobile .form-inputs {
    padding: 0px 0px 20px 0px;
}

.form-inputs-loading {
    font-size: 24px;
    color: #00583D;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.form-button {
    border: 1px solid #00573C;
    border-radius: 8px;
    text-transform: uppercase;
    color: #00573C;
    font-weight: 500;
    width: 200px;
    margin: 0px auto;
    text-align: center;
    font-size: 16px;
    line-height: 70px;
    cursor: pointer;
    font-family: "Montserrat", sans-serif;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAABLCAMAAADXnC7SAAAAP1BMVEUAAAAAWD0AWDwAWT0AVzwAVz0AYEAAWD0AWD0AWjoAWD0AVz4AWD0AWT0AWEAAWD0AWT0AVz0AWD0AVz4AWD11/yeTAAAAFHRSTlMAwEA/l/AQgGAw4M+gcCDQUK+wb6KSSSIAAAFPSURBVEjH7ZbbjoMgEIbBylk88v7PuvgbpAii7SZ7sfG7aArzDQyDiZIScnLOLJzcQ2oHmLiT0cDeYMuVzSeIoufbLqapL85WaVBbXRiIyuLtVnY6pvxMNwj3JKL0uoA615k8TM5IONOHPGLLCf16uK5UqkRCafWOgDsJXarnCYanRUKvJUwk0kCvsF6EjcVr3xlOagz+CPvFCAxqoH00/Pebje+xiYJJHU4o997Mx14BSt6gzumteh9RSaToq7CBRSD1hQfThQ00qk8DxHP0R9SB05IrHzC/L9LoPX/GTIusuh+vCVF55cenBtHmE59d+RH47ktfvQIm+Oa1c/RHl4Bogk39LvdZMkNTnybBFu2u+vg95T/6EW3DayxCL/sPPfq/u1/Cm50h+EOc458+n4//+I//+I//9/7yArXvARD8HPgZX/mizRGrb9sC5AfRP0w/lq0OrwAAAABJRU5ErkJggg==');
    background-repeat: no-repeat;
    background-position: 20px 50%;
    background-size: auto 41px;
}

.is-tablet .form-button {
    font-size: 14px;
}

.is-mobile .form-button {
    background-size: 18px auto;
    font-size: 13px;
    line-height: 54px;
}

.form-button:hover {
    color: #fff;
    background-color: #00573C;
}

.form-button.is-disabled {
	pointer-events: none;
	opacity: 0.25;
}

.form-button.is-errored {
	color: #fff;
	background-color: #cc6e73;
}

.form-message {
	text-align: center;
	font-size: 16px;
	line-height: 20px;
    font-family: "Montserrat", sans-serif;
	padding: 20px;
    font-weight: 500;
	border-radius: 5px;
    margin-bottom: 20px;
}

.form-message.is-success {
	background-color: #BBD9CD;
}

.form-message.is-error {
	background-color: #cc6e73;
    color: #fff;
}

</style>
